import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import { useSelector } from 'react-redux';
import Loading from '../Loading';
import { useStyles } from './styles';

const GlobalSpinner = () => {
  const {
    vaultRequest: { loading: isVaultRequestLoading },
    buyerContact: { loading: isBuyerContactLoading },
    vaultCard: { loading: isVaultCardLoading },
    hyperlink: { loading: isHyperLinkLoading },
    user: { loading: isUserLoading },
  } = useSelector((state) => state);
  const classes = useStyles();
  const open =
    isVaultRequestLoading ||
    isBuyerContactLoading ||
    isVaultCardLoading ||
    isHyperLinkLoading ||
    isUserLoading;
  return (
    <Dialog open={open} classes={{ paper: classes.dialogPaper }}>
      <Loading />
    </Dialog>
  );
};

export default GlobalSpinner;
